import { Selected } from '../../../forms/hocs/selected-options'
import { FilterName } from '../../../__generated__/fed-graphql-types'

export const validNameCharsRegEx = 'a-zA-Z0-9-_ £.,'
const isNameTooLongNow = (currentString: string, append: string) => currentString.length + append.length > 30
const getValidText = (value: string): string => value.replace(new RegExp(`[^${validNameCharsRegEx}]`, 'g'), '').trim()

const searchName = (make?: string, model?: string, distance?: string) => {
    let name = ''

    if (make) {
        name += getValidText(make)

        if (model) {
            const validModelChars = getValidText(model)
            if (!isNameTooLongNow(name, ` ${validModelChars}`)) {
                name += ` ${validModelChars}`
            }
        }
    } else {
        name += 'Search'
    }

    if (!make && !model && !distance) {
        const appendNationally = ' nationally'
        if (!isNameTooLongNow(name, appendNationally)) {
            name += ' nationally'
        }
    }

    return name
}

/* This logic was originally taken from the existing code in sauron. We had to preserve the same functionality */
export const generateName = (filters: Map<FilterName, Selected>): string => {
    const make: string | undefined = filters.get(FilterName.make)?.values[0]
    const model: string | undefined = filters.get(FilterName.model)?.values[0]
    const distance: string | undefined = filters.get(FilterName.distance)?.values[0]

    return searchName(make, model, distance)
}
